module.exports = __webpack_public_path__ + "img/ET.5f3555af.svg";